<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ utils.getLangTerm('task_analysis_documents.singular', 'Task Analysis Document') }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    [mat-dialog-close]="hasChanges"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <form #f="ngForm" (ngSubmit)="onSubmit(f)">
    <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Name</mat-label>
      <input
        matInput
        placeholder="Name"
        [(ngModel)]="task_analysis.task_name"
        name="task_name"
        type="text"
        #task_name
        required />
      <mat-hint>
        Please enter a name.
      </mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
  <button
    *ngIf="task_analysis.id ? canEdit : canCreate"
    (click)="onSubmit(f)"
    mat-raised-button
    [disabled]="!f.valid || inProgress"
    color="primary"
    class="my-2 ml-1 mr-2">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <app-file-browse-button
    (selectedFiles)="onSelectFiles($event)"
    (afterDialogClosedEvent)="onSubmit(f)"
    parentObjectType="task_analysis"
    [parentObjectId]="task_analysis?.id"
    [filesCount]="task_analysis?.files?.length">
  </app-file-browse-button>

  <button
    class="my-2 ml-1 mr-2"
    (click)="onSelectSites()"
    mat-raised-button
    [matBadge]="'' + task_analysis.site_ids?.length"
    color="secondary"
    type="button">
    <mat-icon>location_on</mat-icon>
    Select {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
  </button>

  <button
    *ngIf="canDelete"
    type="button"
    color="warn"
    mat-icon-button
    [disabled]="!task_analysis?.id || task_analysis?.id === 'new'"
    class="dialog-remove-button my-2 ml-auto mr-1"
    (click)="onRemove()"
    matTooltip="Delete this record.">
    <mat-icon>delete</mat-icon>
  </button>
</mat-dialog-actions>
